$( document ).ready(function( $ ) {

    setTimeout(() => {
      // h1 Elemente ersetzen
      const h1Elements = document.querySelectorAll('h1[id^="modalTitle-"]');
      h1Elements.forEach(h1Element => {
        const h2Element = document.createElement('h2');
        Array.from(h1Element.attributes).forEach(attr => {
          h2Element.setAttribute(attr.nodeName, attr.nodeValue);
        });
        h2Element.textContent = h1Element.textContent;
        h1Element.parentNode.replaceChild(h2Element, h1Element);
      });

      // Aussagekräftiger Titel
      let videos = document.querySelectorAll('.video-js-box');
      videos.forEach(video => {
        let playBtn = video.querySelector('.able-big-play-button');
        let title = playBtn.getAttribute('aria-label')+': '+video.querySelector('.video-title').innerHTML;
        playBtn.setAttribute('aria-label', title);
      });
    }, 1000);
});
